import { ajaxV4 } from '@/util/ajax-v4'
const BASE_URL = '/servicebus'

const TfaApi = {
  checkTfaValidation (input, success, failure) {
    return ajaxV4.post(
      `${BASE_URL}/auth/tfa-validation`,
      input,
      success,
      failure
    )
  },
  sendTfaCaptcha (input, success, failure) {
    return ajaxV4.post(
      `${BASE_URL}/auth/tfa-captcha/send`,
      input,
      success,
      failure
    )
  },
  verifyTfaCaptcha (input, success, failure) {
    return ajaxV4.post(
      `${BASE_URL}/auth/tfa-captcha/verify`,
      input,
      success,
      failure
    )
  }

}
export { TfaApi }
